export const promoActive = true;

export const promoData = {
  plansOnPromo: {
    "Jetons SEO": 40, // 20% de réduction pour les jetons
    Starter: 40, // 40% de réduction pour Starter
    Avancé: 40, // 40% de réduction pour Avancé
    Expert: 40, // 40% de réduction pour Expert
  },
};
